import axios from 'axios';
import router from "../router";
var ui = require('element-plus')
const baseURL = 'https://wx.yixiankeji.com/'
// const baseURL = 'http://192.168.0.19:8086/'
const service = axios.create({
    baseURL: baseURL,
    timeout: 5000
});

service.interceptors.request.use(
    config => {
        const overTime = localStorage.getItem("overTime")
        let token = localStorage.getItem("token")
        if (overTime === undefined || overTime < (Date.parse(new Date()) - (43200*1000))) { // 3600*1000 毫秒级
                    router.replace({
                        path: "/login"
                    })
                localStorage.setItem("overTime", Date.parse(new Date()))
        }
        if (config.headers['Content-type'] === "") {
            config.headers['Content-Type'] = 'application/text/html;charset=utf-8'
        }
        config.headers.authorization = token
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    
    response => {

        if (response.status === 200) {
            return response.data;
        }
        Promise.reject();
    },
    error => {
        const res = error.response
        if (res.status !== undefined && res.status === 401) {
            router.replace({
                path: "/login"
            })
            return
        }
        if (res.status !== undefined && res.status === 500 && res.data === '非法访问') {
            router.replace({
                path: "/login"
            })
            ui.ElMessage({
                message: '请不要在一个浏览器同时登录两个不同的账号',
                type: 'error'
            })
            return
        }
        const data = res.data
        ui.ElMessage({
            message: data,
            type: 'error'
        })
        return Promise.reject(data);
    }
);

export default service;
